import RouteProvider from './RouteProvider';

export default RouteProvider;
